// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/ui/components/Spinner.module.css';
import {Trans} from '@lingui/react/macro';
import {clsx} from 'clsx';
import {observer} from 'mobx-react-lite';

interface SpinnerProps {
	className?: string;
	size?: 'small' | 'medium' | 'large';
}
export const Spinner = observer(function Spinner({className, size = 'medium'}: SpinnerProps) {
	return (
		<span className={clsx(styles.spinner, className)}>
			<span className={styles.spinnerInner}>
				<span className={clsx(styles.spinnerItem, styles[size])} />
				<span className={clsx(styles.spinnerItem, styles[size], styles.delay1)} />
				<span className={clsx(styles.spinnerItem, styles[size], styles.delay2)} />
			</span>
			<span className={styles.srOnly}>
				<Trans>Loading...</Trans>
			</span>
		</span>
	);
});
